// extracted by mini-css-extract-plugin
export default {"taskCard":"Task_taskCard__XbfWB","cardBody":"Task_cardBody__kF8ZG","cardBodyStatus":"Task_cardBodyStatus__hgBu4","cardText":"Task_cardText__G+fTk"};